import { captureException } from '@sentry/react'
import { useState } from 'react'

import type { ReactElement } from 'react'

import ModalRoleEdit from './ModalRoleEdit'

import Button from '~/components/Buttons/Button'
import Label from '~/components/Label'
import { displayToast } from '~/utils/toast'

import './styles.scss'

interface Props {
  description?: string
  id: string
  name: string
}

const RoleGeneralInformation = ({ description, id, name }: Props): ReactElement => {
  /** Local state */

  const [isModalOpen, setIsModalOpen] = useState(false)

  /** Handlers */

  const handleModalState = (isOpen: boolean) => () => setIsModalOpen(isOpen)

  const handleSuccess = () => {
    setIsModalOpen(false)
    displayToast('Role successfully updated', 'success')
  }

  const handleFailure = (e: unknown) => {
    captureException(e)
    setIsModalOpen(false)
    displayToast('Role could not be updated', 'error')
  }

  /** Render */

  return (
    <div className="role-details-general-information">
      <div className="input-container">
        <Label className="label" label="Name" />
        <span className="value-container" title={name}>
          {name}
        </span>
      </div>
      <div className="input-container">
        <Label className="label" label="Description" />
        <span className="value-container" title={description}>
          {description || '-'}
        </span>
      </div>
      <div className="actions-container">
        <Button onClick={handleModalState(true)} outlined size="small">
          Edit
        </Button>
      </div>
      <ModalRoleEdit
        description={description}
        id={id}
        isOpen={isModalOpen}
        name={name}
        onClose={handleModalState(false)}
        onFailure={handleFailure}
        onSuccess={handleSuccess}
      />
    </div>
  )
}

export default RoleGeneralInformation
